import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './SucursalesData.css'
import baseURL from '../../url';
import NewSucursal from '../NewSucursal/NewSucursal';

export default function SucursalesData() {
    const [sucursales, setSucursales] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [sucursalActual, setSucursalActual] = useState({});
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevaUrl, setNuevaUrl] = useState('');

    useEffect(() => {
        cargarSucursales();
    }, []);

    useEffect(() => {
        setNuevoNombre(sucursalActual.nombre || '');
        setNuevaUrl(sucursalActual.url || '');
    }, [sucursalActual]);

    const cargarSucursales = () => {
        fetch(`${baseURL}/sucursalesGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSucursales(data.sucursales || []);
            })
            .catch(error => console.error('Error al cargar sucursales:', error));
    };

    const eliminarSucursal = (idSucursal) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/sucursalDelete.php?idSucursal=${idSucursal}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminada!',
                            data.mensaje,
                            'success'
                        );
                        cargarSucursales();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la sucursal:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setSucursalActual(item);
        setNuevoNombre(item.nombre);
        setNuevaUrl(item.url);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const recargarSucursales = () => {
        cargarSucursales();
    };

    const handleUpdate = (idSucursal) => {
        // Validaciones
        if (!nuevoNombre.trim() || !nuevaUrl.trim()) {
            toast.error('Todos los campos son obligatorios');
            return;
        }

        // Validar formato de URL
        try {
            new URL(nuevaUrl);
        } catch (error) {
            toast.error('La URL no es válida. Debe incluir http:// o https://');
            return;
        }

        const formData = new FormData();
        formData.append('nombre', nuevoNombre);
        formData.append('url', nuevaUrl);

        fetch(`${baseURL}/sucursalPut.php?idSucursal=${idSucursal}`, {
            method: 'PUT',
            body: new URLSearchParams(formData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error!', data.error, 'error');
                } else {
                    Swal.fire('¡Actualizado!', data.mensaje, 'success');
                    cargarSucursales();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    return (
        <div>
            
            <div className='deFlexContent'>
                <div className='deFlex2'>
                    <NewSucursal />
                </div>
                <div className='filtrosContain'>
                    <button className='reload' onClick={recargarSucursales}>
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                </div>
            </div>

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>Editar Sucursal</h3>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        
                        <div className='flexGrap'>
                            <fieldset>
                                <legend>Nombre de la Sucursal</legend>
                                <input
                                    type="text"
                                    value={nuevoNombre}
                                    onChange={(e) => setNuevoNombre(e.target.value)}
                                    required
                                />
                            </fieldset>
                            <fieldset>
                                <legend>URL de la Sucursal</legend>
                                <input
                                    type="url"
                                    value={nuevaUrl}
                                    onChange={(e) => setNuevaUrl(e.target.value)}
                                    required
                                />
                            </fieldset>
                        </div>
                        <button className='btnPost' onClick={() => handleUpdate(sucursalActual.idSucursal)}>
                            Guardar Cambios
                        </button>
                    </div>
                </div>
            )}
            
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>URL</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sucursales.length > 0 ? (
                            sucursales.map(item => (
                                <tr key={item.idSucursal}>
                                    <td>{item.idSucursal}</td>
                                    <td>{item.nombre}</td>
                                    <td>
                                        <a href={item.url} target="_blank" rel="noopener noreferrer" className='linkUrl'>
                                            {item.url} <FontAwesomeIcon icon={faExternalLinkAlt} />
                                        </a>
                                    </td>
                                    <td>
                                        <button className='editar' onClick={() => abrirModal(item)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className='eliminar' onClick={() => eliminarSucursal(item.idSucursal)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{textAlign: 'center', padding: '20px', color: '#999'}}>
                                    No hay sucursales registradas
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}



